"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.string.starts-with");

require("core-js/modules/es6.string.ends-with");

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.regexp.search");

require("core-js/modules/es6.regexp.match");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.set");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.function.name");

require("core-js/modules/es7.array.includes");

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));

require("core-js/modules/es7.string.pad-start");

require("core-js/modules/es6.array.find");

var _toConsumableArray2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/toConsumableArray.js"));

require("core-js/modules/es6.number.constructor");

var _commonUpload = _interopRequireDefault(require("@/views/cms/common/commonUpload"));

var _AddressCascader = _interopRequireDefault(require("@/views/cms/common/AddressCascader"));

var _car = require("@/api/cms/car");

var _driverInfo = require("@/api/cms/driverInfo");

var _validate = require("@/utils/validate");

var _send = require("@/api/cms/send");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = {
  name: 'DeliveryPeisong',
  components: {
    CommonUpload: _commonUpload.default,
    AddressCascader: _AddressCascader.default
  },
  props: {
    form: {
      type: Object,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    },
    sendStatus: {
      type: Number,
      default: null
    },
    deliveryLog: {
      type: Object,
      default: null
    },
    customerInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    amapApi: {
      type: String,
      default: ''
    },
    amapSecurityJsCode: {
      type: String,
      default: ''
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    initiator: {
      type: String,
      default: ''
    },
    initiateTime: {
      type: String,
      default: ''
    },
    submitting: {
      type: Boolean,
      default: false
    },
    allDriverList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    contractList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    detailId: {
      type: [String, Number],
      default: null
    },
    accountingTotalPackages: {
      type: Number,
      default: 0
    },
    accountingTotalInPackages: {
      type: Number,
      default: 0
    },
    accountingTotalArea: {
      type: Number,
      default: 0
    },
    accountingTotalVol: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      vehicleList: [],
      allVehicleList: [],
      driverList: [],
      driverSearchLoading: false,
      selectedVehicles: [],
      dateList: [],
      attachmentList: [],
      refreshing: false,
      mapDialogVisible: false,
      searchKeyword: '',
      searchResults: [],
      showSearchResults: false,
      map: null,
      marker: null,
      tempCoordinate: '',
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      logData: null,
      reserveCountdownText: '00:00:00',
      departCountdownText: '00:00:00',
      accountingSubmitting: false,
      accountingSaving: false,
      _countdownTimer: null,
      _loadingLog: null
    };
  },
  computed: {
    driverIds: function driverIds() {
      if (this.form.deliveryDriver && this.form.deliveryDriver.length > 0) {
        return (0, _toConsumableArray2.default)(this.form.deliveryDriver);
      }

      var ids = this.selectedVehicles.length > 0 ? this.selectedVehicles.map(function (v) {
        return v.userId;
      }) : (this.form.deliveryPersons || []).map(function (p) {
        return p.userId;
      });
      return ids.filter(Boolean);
    },
    driverDisplayNames: function driverDisplayNames() {
      var _this = this;

      if (!this.form.deliveryDriver || this.form.deliveryDriver.length === 0) return '-';
      return this.form.deliveryDriver.map(function (id) {
        var d = _this.allDriverList.find(function (item) {
          return item.userId === id;
        });

        if (d) {
          return d.phone ? "".concat(d.realName, " ").concat(d.phone) : d.realName;
        }

        return id;
      }).join(', ');
    },
    startTimePickerOptions: function startTimePickerOptions() {
      var base = {
        start: '00:00',
        step: '01:00',
        end: '24:00'
      };
      var now = new Date();
      var todayStr = now.getFullYear() + '-' + String(now.getMonth() + 1).padStart(2, '0') + '-' + String(now.getDate()).padStart(2, '0'); // 上门日期为空或为当天时，开始时间不能早于当前时间

      if (!this.form.sendDate || this.form.sendDate === todayStr) {
        base.minTime = String(now.getHours()).padStart(2, '0') + ':' + String(now.getMinutes()).padStart(2, '0');
      }

      return base;
    },
    previewAttachmentList: function previewAttachmentList() {
      var _this2 = this;

      if (!this.attachmentList || this.attachmentList.length === 0) return [];
      var imgPreviewPrefix = this.$store.getters.imgPreviewPrefix || '';
      var filePreviewPrefix = this.$store.getters.filePreviewPrefix || '';
      return this.attachmentList.map(function (item) {
        var parsed = typeof item === 'string' ? JSON.parse(item) : item;
        var name = parsed.localName || parsed.alias || parsed.realName || '';

        var isImage = _this2.isImageFile(name);

        var prefix = isImage ? imgPreviewPrefix : filePreviewPrefix;
        return {
          url: parsed.url || prefix + parsed.realName,
          name: name,
          isImage: isImage
        };
      });
    }
  },
  watch: {
    'form.deliveryDriver': {
      handler: function handler() {
        this.loadVehicleList();
      },
      deep: true
    },
    deliveryLog: {
      immediate: true,
      handler: function handler(val) {
        if (val) {
          this.logData = val;
        }
      }
    },
    sendStatus: {
      immediate: true,
      handler: function handler() {
        this.startCountdown();
      }
    },
    'form.deliveryNo': {
      immediate: true,
      handler: function handler(val) {
        if (val && this.isEdit && !this.deliveryLog) {
          this.loadLog();
        }
      }
    },
    allDriverList: {
      handler: function handler(val) {
        if (val && val.length > 0 && this.driverList.length === 0) {
          this.driverList = val.slice(0, 10);
          this.loadVehicleList();
        }
      }
    }
  },
  mounted: function () {
    var _mounted = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              this._firstActivated = true;
              this.loadAllVehicleList();
              _context.next = 4;
              return this.loadDriverList();

            case 4:
              this.loadVehicleList();

              if (this.form.deliveryNo && this.isEdit && !this.deliveryLog) {
                this.loadLog();
              }

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function mounted() {
      return _mounted.apply(this, arguments);
    }

    return mounted;
  }(),
  activated: function () {
    var _activated = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!this._firstActivated) {
                _context2.next = 3;
                break;
              }

              this._firstActivated = false;
              return _context2.abrupt("return");

            case 3:
              this.loadAllVehicleList();
              _context2.next = 6;
              return this.loadDriverList();

            case 6:
              this.loadVehicleList();

              if (this.form.deliveryNo && this.isEdit && !this.deliveryLog) {
                this.loadLog();
              }

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function activated() {
      return _activated.apply(this, arguments);
    }

    return activated;
  }(),
  beforeDestroy: function beforeDestroy() {
    if (this._countdownTimer) clearInterval(this._countdownTimer);
  },
  methods: {
    // ==================== 附件处理 ====================
    isImageFile: function isImageFile(fileName) {
      if (!fileName) return false;
      var imgExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.bmp'];
      var ext = fileName.substring(fileName.lastIndexOf('.')).toLowerCase();
      return imgExtensions.includes(ext);
    },
    downloadAttachment: function downloadAttachment(item) {
      if (item.url) {
        fetch(item.url, {
          mode: 'cors'
        }).then(function (res) {
          return res.blob();
        }).then(function (blob) {
          var blobUrl = URL.createObjectURL(blob);
          var a = document.createElement('a');
          a.href = blobUrl;
          a.download = item.name;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          URL.revokeObjectURL(blobUrl);
        }).catch(function () {
          window.open(item.url, '_blank');
        });
      }
    },
    handleAttachmentUpload: function handleAttachmentUpload(filePaths) {
      this.attachmentList = filePaths;
      this.$emit('attachment-change', filePaths);
    },
    handleAttachmentDel: function handleAttachmentDel(filePaths) {
      this.attachmentList = filePaths;
      this.$emit('attachment-change', filePaths);
    },
    handleAddressCoordinateChange: function handleAddressCoordinateChange(coord) {
      if (coord && coord.lng && coord.lat) {
        this.form.coordinate = "".concat(coord.lng, ", ").concat(coord.lat);
      }
    },
    // ==================== 车辆/司机 ====================
    loadAllVehicleList: function () {
      var _loadAllVehicleList = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _this3 = this;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", (0, _car.getCarList)({
                  page: 0,
                  size: 10000
                }).then(function (res) {
                  if (res.data && res.data.content) {
                    _this3.allVehicleList = res.data.content.map(function (car) {
                      return {
                        id: car.id,
                        licensePlate: car.carNumber,
                        brand: car.brand,
                        style: car.style,
                        energy: car.energy,
                        volume: car.volume,
                        length: car.size ? car.size.split('x')[0] : '',
                        width: car.size ? car.size.split('x')[1] : '',
                        height: car.size ? car.size.split('x')[2] : '',
                        status: car.status
                      };
                    });
                  }
                }).catch(function (err) {
                  console.error('加载所有车辆列表失败:', err);
                }));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function loadAllVehicleList() {
        return _loadAllVehicleList.apply(this, arguments);
      }

      return loadAllVehicleList;
    }(),
    loadDriverList: function loadDriverList() {
      if (this.allDriverList && this.allDriverList.length > 0) {
        this.driverList = this.allDriverList.slice(0, 10);
      }

      return Promise.resolve();
    },
    searchDriver: function searchDriver(query) {
      var _this4 = this;

      if (!query) {
        this.loadDriverList();
        return;
      }

      this.driverSearchLoading = true;
      (0, _driverInfo.getDriverInfoList)({
        query: query,
        page: 0,
        size: 20
      }).then(function (res) {
        if (res.code === 200 && res.data && res.data.content) {
          _this4.driverList = res.data.content;
        }
      }).catch(function (err) {
        console.error('搜索司机失败:', err);
      }).finally(function () {
        _this4.driverSearchLoading = false;
      });
    },
    // ==================== 司机排班 ====================
    initDateList: function initDateList(startDate) {
      var dates = [];
      var baseDate;

      if (startDate) {
        baseDate = new Date(startDate);
      } else {
        baseDate = new Date();
      }

      for (var i = 0; i < 7; i++) {
        var d = new Date(baseDate);
        d.setDate(d.getDate() + i);
        dates.push(d);
      }

      this.dateList = dates;
    },
    loadVehicleList: function () {
      var _loadVehicleList = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var _this5 = this;

        var topDrivers, top10DriverIds, scheduleRes;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                this.initDateList();

                if (!(this.driverIds.length === 0)) {
                  _context4.next = 21;
                  break;
                }

                // 复用已加载的 driverList 或父组件传入的 allDriverList，避免重复请求
                topDrivers = this.driverList.length > 0 ? this.driverList : this.allDriverList && this.allDriverList.length > 0 ? this.allDriverList.slice(0, 10) : [];

                if (!(topDrivers.length > 0)) {
                  _context4.next = 18;
                  break;
                }

                top10DriverIds = topDrivers.map(function (d) {
                  return d.userId;
                });
                _context4.prev = 5;
                _context4.next = 8;
                return (0, _driverInfo.getDriverSchedule)({
                  userIds: top10DriverIds.join(',')
                });

              case 8:
                scheduleRes = _context4.sent;

                if (!(scheduleRes.code === 200 && scheduleRes.data)) {
                  _context4.next = 13;
                  break;
                }

                this.vehicleList = this._buildVehicleList(scheduleRes.data || []);
                this.selectedVehicles = [];
                return _context4.abrupt("return");

              case 13:
                _context4.next = 18;
                break;

              case 15:
                _context4.prev = 15;
                _context4.t0 = _context4["catch"](5);
                console.error('加载司机状态列表失败:', _context4.t0);

              case 18:
                this.vehicleList = [];
                this.selectedVehicles = [];
                return _context4.abrupt("return");

              case 21:
                return _context4.abrupt("return", (0, _driverInfo.getDriverSchedule)({
                  userIds: this.driverIds.join(',')
                }).then(function (res) {
                  if (res.code === 200 && res.data) {
                    _this5.vehicleList = _this5._buildVehicleList(res.data || []);

                    if (_this5.isEdit && _this5.form.deliveryVehiclePlates && _this5.form.deliveryVehiclePlates.length > 0) {
                      _this5.selectedVehicles = _this5.vehicleList.filter(function (v) {
                        return _this5.form.deliveryVehiclePlates.includes(v.userId);
                      });

                      _this5.vehicleList.forEach(function (v) {
                        _this5.$set(v, '_checked', _this5.form.deliveryVehiclePlates.includes(v.userId));
                      });
                    }
                  }
                }).catch(function (err) {
                  console.error('加载司机状态列表失败:', err);
                }));

              case 22:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[5, 15]]);
      }));

      function loadVehicleList() {
        return _loadVehicleList.apply(this, arguments);
      }

      return loadVehicleList;
    }(),
    _buildVehicleList: function _buildVehicleList(data) {
      return data.map(function (driver) {
        var schedule = {};

        if (driver.taskTimes && driver.taskTimes.length > 0) {
          driver.taskTimes.forEach(function (task) {
            if (!schedule[task.taskDate]) {
              schedule[task.taskDate] = {
                status: 0,
                taskTimes: []
              };
            }

            if (task.taskTime) {
              schedule[task.taskDate].taskTimes.push(task.taskTime);
            }
          });
        }

        return {
          id: driver.id,
          userId: driver.userId,
          driverName: driver.driverName,
          driverPhone: driver.driverPhone,
          licensePlate: '',
          status: driver.status || 0,
          taskTimes: driver.taskTimes || [],
          sendList: driver.sendList || [],
          schedule: schedule,
          _checked: false
        };
      });
    },
    orderRowClassName: function orderRowClassName() {
      return 'order-row-hover';
    },
    handleVehicleSelect: function handleVehicleSelect(row) {
      if (row._checked) {
        if (!this.selectedVehicles.find(function (v) {
          return v.id === row.id;
        })) {
          this.selectedVehicles.push(row);
        }
      } else {
        this.selectedVehicles = this.selectedVehicles.filter(function (v) {
          return v.id !== row.id;
        });
      }

      if (this.selectedVehicles.length === 0) {
        this.form.deliveryPersons = [];
        this.form.deliveryVehiclePlates = [];
      } else {
        this.form.deliveryPersons = this.selectedVehicles.map(function (v) {
          return {
            userId: v.userId,
            userName: v.driverName
          };
        });
        this.form.deliveryVehiclePlates = this.selectedVehicles.map(function (v) {
          return v.userId;
        });
      }
    },
    handleVehicleRowClick: function handleVehicleRowClick(row) {
      row._checked = !row._checked;
      this.handleVehicleSelect(row);
    },
    handleSendDateChange: function handleSendDateChange(date) {
      if (!date || this.selectedVehicles.length === 0) return;
      var dateKey = this.getScheduleDateKey(date);
      var unavailableVehicles = [];
      this.selectedVehicles.forEach(function (vehicle) {
        if (vehicle.status === 1) {
          unavailableVehicles.push("".concat(vehicle.driverName, "(\u7EF4\u4FEE\u4E2D)"));
        } else if (vehicle.status === 3) {
          unavailableVehicles.push("".concat(vehicle.driverName, "(\u4F11\u606F\u4E2D)"));
        } else if (vehicle.schedule && vehicle.schedule[dateKey]) {
          var scheduleInfo = vehicle.schedule[dateKey];

          if (scheduleInfo.status === 1) {
            unavailableVehicles.push("".concat(vehicle.driverName, "(\u7EF4\u4FEE\u4E2D)"));
          } else if (scheduleInfo.status === 3) {
            unavailableVehicles.push("".concat(vehicle.driverName, "(\u4F11\u606F\u4E2D)"));
          }
        }
      });

      if (unavailableVehicles.length > 0) {
        this.$message.error("\u4EE5\u4E0B\u53F8\u673A\u5728\u6240\u9009\u65E5\u671F\u4E0D\u53EF\u7528\uFF1A".concat(unavailableVehicles.join('、')));
        this.form.sendDate = '';
      }
    },
    handleDoorTimeChange: function handleDoorTimeChange() {
      if (!this.form.sendDate) {
        var now = new Date();
        this.form.sendDate = now.getFullYear() + '-' + String(now.getMonth() + 1).padStart(2, '0') + '-' + String(now.getDate()).padStart(2, '0');
      }
    },
    getScheduleDateKey: function getScheduleDateKey(dateStr) {
      if (!dateStr) return '';

      if (dateStr instanceof Date) {
        var month = String(dateStr.getMonth() + 1).padStart(2, '0');
        var day = String(dateStr.getDate()).padStart(2, '0');
        return "".concat(month, "-").concat(day);
      }

      var parts = dateStr.split('-');
      if (parts.length < 2) return dateStr;
      return "".concat(String(parts[parts.length - 2]).padStart(2, '0'), "-").concat(String(parts[parts.length - 1]).padStart(2, '0'));
    },
    getScheduleStatusByPeriod: function getScheduleStatusByPeriod(schedule, date, period) {
      if (!schedule || !schedule[date]) return '空闲';
      var scheduleInfo = schedule[date];
      if (scheduleInfo.status === 1) return '维修';
      if (scheduleInfo.status === 3) return '休息';

      if (scheduleInfo.taskTimes && scheduleInfo.taskTimes.length > 0) {
        var filtered = scheduleInfo.taskTimes.filter(function (timeStr) {
          var parts = timeStr.split('-');

          if (parts.length < 2) {
            if (timeStr === '上午') return period === 'am';
            if (timeStr === '下午') return period === 'pm';
            if (timeStr === '全天') return true;
            return false;
          }

          var startHour = parseInt(parts[0].split(':')[0]);
          var endHour = parseInt(parts[1].split(':')[0]);
          if (period === 'am') return startHour < 12;
          return endHour > 12;
        });
        if (filtered.length > 0) return filtered;
        return '空闲';
      }

      return '已排班';
    },
    getScheduleCellClassByPeriod: function getScheduleCellClassByPeriod(row, date, period) {
      if (row.status === 1) return 'busy';
      if (row.status === 3) return 'rest';
      var status = this.getScheduleStatusByPeriod(row.schedule, date, period);
      if (status === '维修') return 'busy';
      if (status === '休息') return 'rest';
      if (status === '空闲' && this.getSendTimeList(row, date, period).length === 0) return 'free';
      return 'occupied';
    },
    hasScheduleData: function hasScheduleData(row, date, period) {
      var status = this.getScheduleStatusByPeriod(row.schedule, date, period);
      if (status === '空闲' && this.getSendTimeList(row, date, period).length === 0) return false;
      return true;
    },
    getSendTimeList: function getSendTimeList(row, date, period) {
      if (!row.sendList || row.sendList.length === 0) return [];
      var dateStr = date;
      return (0, _toConsumableArray2.default)(new Set(row.sendList.filter(function (item) {
        if (!item.sendDate || !item.sendTime) return false;
        var sendDate = new Date(item.sendDate);
        var month = String(sendDate.getMonth() + 1).padStart(2, '0');
        var day = String(sendDate.getDate()).padStart(2, '0');
        var sendDateStr = "".concat(month, "-").concat(day);
        if (sendDateStr !== dateStr) return false;
        var timeStr = item.sendTime;
        var parts = timeStr.split('-');

        if (parts.length < 2) {
          return timeStr === (period === 'am' ? '上午' : '下午') || timeStr === '全天';
        }

        var startHour = parseInt(parts[0].split(':')[0]);
        var endHour = parseInt(parts[1].split(':')[0]);
        if (period === 'am') return startHour < 12;
        return endHour > 12;
      }).map(function (item) {
        return item.sendTime;
      })));
    },
    getTaskTimeList: function getTaskTimeList(row, date, period) {
      if (!row.taskTimes || row.taskTimes.length === 0) return [];
      var dateStr = date;
      return row.taskTimes.filter(function (item) {
        if (!item.taskDate || !item.taskTime) return false;
        if (item.taskDate !== dateStr) return false;
        var parts = item.taskTime.split('-');

        if (parts.length < 2) {
          return item.taskTime === (period === 'am' ? '上午' : '下午') || item.taskTime === '全天';
        }

        var startHour = parseInt(parts[0].split(':')[0]);
        var endHour = parseInt(parts[1].split(':')[0]);
        if (period === 'am') return startHour < 12;
        return endHour > 12;
      }).map(function (item) {
        return item.taskTime;
      });
    },
    // ==================== 地图 ====================
    formatDate: function formatDate(date, format) {
      if (!date) return '';
      var d = date instanceof Date ? date : new Date(date);
      var month = String(d.getMonth() + 1).padStart(2, '0');
      var day = String(d.getDate()).padStart(2, '0');
      if (format === 'MM-DD') return "".concat(month, "-").concat(day);

      if (format === 'EEE') {
        var weekdays = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
        return weekdays[d.getDay()];
      }

      return "".concat(month, "-").concat(day);
    },
    openMapSelector: function openMapSelector() {
      var _this6 = this;

      this.mapDialogVisible = true;
      this.$nextTick(function () {
        _this6.initMap();
      });
    },
    handleMapClose: function handleMapClose() {
      if (this.map) {
        this.map.destroy();
        this.map = null;
      }
    },
    initMap: function initMap() {
      var _this7 = this;

      if (this.map) {
        this.map.destroy();
        this.map = null;
      }

      this.tempCoordinate = this.form.coordinate || '';

      var loadMapScript = function loadMapScript() {
        return new Promise(function (resolve, reject) {
          if (typeof window.AMap !== 'undefined') {
            resolve();
            return;
          }

          window._AMapSecurityConfig = {
            securityJsCode: _this7.amapSecurityJsCode
          };
          var callbackName = 'initAmapDelivery_' + Date.now();

          window[callbackName] = function () {
            resolve();
            delete window[callbackName];
          };

          var script = document.createElement('script');
          script.type = 'text/javascript';
          script.src = _this7.amapApi + '&callback=' + callbackName;
          script.async = true;
          script.defer = true;
          script.onerror = reject;
          document.head.appendChild(script);
        });
      };

      loadMapScript().then(function () {
        _this7.createMap();
      }).catch(function () {
        _this7.$message.error('地图加载失败，请刷新页面重试');
      });
    },
    createMap: function createMap() {
      var _this8 = this;

      try {
        var center = [108.370859, 22.678838];

        if (this.form.coordinate) {
          var lnglatMatch = this.form.coordinate.match(/(\d+\.\d+),\s*(\d+\.\d+)/);

          if (lnglatMatch) {
            center = [parseFloat(lnglatMatch[1]), parseFloat(lnglatMatch[2])];
          }
        }

        this.map = new window.AMap.Map('mapContainerPeisong', {
          zoom: 14,
          center: center
        });
        window.AMap.plugin(['AMap.Scale', 'AMap.ToolBar'], function () {
          _this8.map.addControl(new window.AMap.Scale());

          _this8.map.addControl(new window.AMap.ToolBar());
        });
        this.marker = new window.AMap.Marker({
          position: center,
          draggable: true
        });
        this.map.add(this.marker);
        this.map.on('click', function (e) {
          _this8.tempCoordinate = "(".concat(e.lnglat.getLng(), ", ").concat(e.lnglat.getLat(), ")");

          _this8.marker.setPosition([e.lnglat.getLng(), e.lnglat.getLat()]);
        });
        this.marker.on('dragend', function () {
          var pos = _this8.marker.getPosition();

          _this8.tempCoordinate = "(".concat(pos.getLng(), ", ").concat(pos.getLat(), ")");
        });
      } catch (e) {
        console.error('地图初始化失败:', e);
        this.$message.error('地图初始化失败，请重试');
      }
    },
    handleSearchInput: function handleSearchInput() {
      if (!this.searchKeyword || this.searchKeyword.length < 2) {
        this.showSearchResults = false;
        return;
      }

      this.searchLocation();
    },
    searchLocation: function searchLocation() {
      var _this9 = this;

      if (!this.searchKeyword) return;

      if (this.map && window.AMap) {
        window.AMap.plugin('AMap.PlaceSearch', function () {
          var placeSearch = new window.AMap.PlaceSearch({
            city: '南宁',
            citylimit: false,
            pageSize: 10,
            pageIndex: 1
          });
          placeSearch.search(_this9.searchKeyword, function (status, result) {
            if (status === 'complete' && result.poiList) {
              _this9.searchResults = result.poiList.pois;
              _this9.showSearchResults = true;
            } else {
              _this9.searchResults = [];
              _this9.showSearchResults = false;
            }
          });
        });
      }
    },
    selectSearchResult: function selectSearchResult(result) {
      var lng = result.location.lng;
      var lat = result.location.lat;
      this.tempCoordinate = "(".concat(lng, ", ").concat(lat, ")");

      if (this.map) {
        this.map.setCenter([lng, lat]);
        this.marker.setPosition([lng, lat]);
      }

      this.showSearchResults = false;
      this.searchKeyword = result.name;
    },
    confirmMapSelection: function confirmMapSelection() {
      if (!this.tempCoordinate) {
        if (this.marker) {
          var pos = this.marker.getPosition();
          this.tempCoordinate = "(".concat(pos.getLng(), ", ").concat(pos.getLat(), ")");
        } else if (this.map) {
          var center = this.map.getCenter();
          this.tempCoordinate = "(".concat(center.getLng(), ", ").concat(center.getLat(), ")");
        }
      }

      if (this.tempCoordinate) {
        this.form.coordinate = this.tempCoordinate.replace(/[()]/g, '');
      }

      this.mapDialogVisible = false;
    },
    // ==================== 外部调用 ====================
    restoreAttachmentList: function restoreAttachmentList(fileList) {
      if (!this.$refs.deliveryAttachment) return;

      if (!fileList || fileList.length === 0) {
        this.$refs.deliveryAttachment.clearImgs();
        return;
      }

      try {
        var imgPreviewPrefix = this.$store.getters.imgPreviewPrefix || '';
        var filePreviewPrefix = this.$store.getters.filePreviewPrefix || '';
        var files = fileList.map(function (item) {
          var o = typeof item === 'string' ? JSON.parse(item) : item;
          var name = (o.localName || o.alias || o.realName || '').toLowerCase();
          var isImage = ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.bmp'].some(function (e) {
            return name.endsWith(e);
          });
          var prefix = isImage ? imgPreviewPrefix : filePreviewPrefix;
          return {
            realName: o.realName,
            url: o.url || prefix + o.realName,
            type: o.type,
            alias: o.localName || o.alias
          };
        });
        this.$refs.deliveryAttachment.setFileList(files);
      } catch (_unused) {}
    },
    getAttachmentList: function getAttachmentList() {
      return this.attachmentList;
    },
    getSelectedVehicles: function getSelectedVehicles() {
      return this.selectedVehicles;
    },
    // ==================== $refs methods ====================
    fillFromEdit: function fillFromEdit(row) {
      var _this10 = this;

      // sendDate, doorTime, deliveryPersons, deliveryVehiclePlates, receivePerson, receivePhone, receiveAddress, coordinate, remark
      // These are set by parent on the shared form. Only set type-specific fields here.
      if (row && row.sendDate) {
        this.form.sendDate = row.sendDate.split(' ')[0];
      }

      if (row && row.sendTime) {
        var st = row.sendTime;

        if (typeof st === 'string' && st.includes('-')) {
          this.form.doorTime = st.split('-');
        } else if (Array.isArray(st)) {
          this.form.doorTime = st;
        } else {
          this.form.doorTime = ['', ''];
        }
      }

      if (row && row.sendPerson) {
        this.form.deliveryPersons = this.parseSendPerson(row.sendPerson);
      }

      if (row && row.carNumber) {
        this.form.deliveryVehiclePlates = row.carNumber.split(',').filter(Boolean);
        this.form.deliveryVehicle = row.carNumber.split(',').filter(Boolean);
      }

      if (row && row.deliveryPersons) {
        this.form.deliveryPersons = row.deliveryPersons;
      }

      if (row && row.deliveryVehiclePlates) {
        this.form.deliveryVehiclePlates = row.deliveryVehiclePlates;
      }

      if (row) {
        this.form.hasLargeFurniture = row.hasProduct || row.hasLargeFurniture || '';
        this.form.enterType = row.enterType || '';
        this.form.enterRemark = row.enterRemark || '';
        this.form.remark = row.remark || '';
        this.form.reserveImage = row.reserveImage || '';
        this.form.reserveTime = row.reserveTime || '';
        this.form.phoneReserveTime = row.phoneReserveTime || '';
        this.form.reserveTimeliness = row.reserveTimeliness || '';

        if (row.attachment) {
          try {
            var list = JSON.parse(row.attachment);
            this.attachmentList = Array.isArray(list) ? list : [];
            this.$nextTick(function () {
              return _this10.restoreAttachmentList(_this10.attachmentList);
            });
          } catch (_unused2) {
            this.attachmentList = [];
          }
        }

        if (row.sendPerson) {
          this.form.deliveryDriver = this.parseSendPerson(row.sendPerson).map(function (p) {
            return p.userId;
          }).filter(Boolean);
        }

        this.$nextTick(function () {
          return _this10.loadVehicleList();
        });
      }
    },
    fillFromCache: function fillFromCache(saveData) {
      var _this11 = this;

      if (!saveData) return;
      if (saveData.sendDate) this.form.sendDate = saveData.sendDate;

      if (saveData.doorTime || saveData.sendTime) {
        var st = saveData.doorTime || saveData.sendTime || '';

        if (Array.isArray(st)) {
          this.form.doorTime = st;
        } else if (st.includes('-')) {
          this.form.doorTime = st.split('-');
        } else {
          this.form.doorTime = [st, ''];
        }
      }

      if (saveData.hasLargeFurniture || saveData.hasProduct) this.form.hasLargeFurniture = saveData.hasLargeFurniture || saveData.hasProduct;
      if (saveData.enterType) this.form.enterType = saveData.enterType;
      if (saveData.enterRemark) this.form.enterRemark = saveData.enterRemark;
      if (saveData.reserveImage) this.form.reserveImage = saveData.reserveImage;
      if (saveData.reserveTime) this.form.reserveTime = saveData.reserveTime;
      if (saveData.phoneReserveTime) this.form.phoneReserveTime = saveData.phoneReserveTime;
      if (saveData.reserveTimeliness) this.form.reserveTimeliness = saveData.reserveTimeliness;
      if (saveData.remark) this.form.remark = saveData.remark;
      if (saveData.coordinate) this.form.coordinate = saveData.coordinate;

      if (saveData.deliveryVehicle && Array.isArray(saveData.deliveryVehicle)) {
        this.form.deliveryVehicle = saveData.deliveryVehicle;
      }

      if (saveData.deliveryDriver && Array.isArray(saveData.deliveryDriver)) {
        this.form.deliveryDriver = saveData.deliveryDriver;
      }

      if (saveData.attachment && Array.isArray(saveData.attachment)) {
        this.attachmentList = saveData.attachment;
        this.$nextTick(function () {
          return _this11.restoreAttachmentList(_this11.attachmentList);
        });
      }

      this.$nextTick(function () {
        return _this11.loadVehicleList();
      });
    },
    buildSaveData: function buildSaveData() {
      return {
        sendDate: this.form.sendDate,
        doorTime: (0, _toConsumableArray2.default)(this.form.doorTime),
        hasLargeFurniture: this.form.hasLargeFurniture,
        enterType: this.form.enterType,
        enterRemark: this.form.enterRemark,
        remark: this.form.remark,
        reserveImage: this.form.reserveImage,
        reserveTime: this.form.reserveTime,
        phoneReserveTime: this.form.phoneReserveTime,
        reserveTimeliness: this.form.reserveTimeliness,
        coordinate: this.form.coordinate,
        deliveryVehicle: this.form.deliveryVehicle.length > 0 ? (0, _toConsumableArray2.default)(this.form.deliveryVehicle) : null,
        deliveryDriver: this.form.deliveryDriver.length > 0 ? (0, _toConsumableArray2.default)(this.form.deliveryDriver) : null,
        deliveryPersons: this.form.deliveryPersons.length > 0 ? (0, _toConsumableArray2.default)(this.form.deliveryPersons) : null,
        deliveryVehiclePlates: this.form.deliveryVehiclePlates.length > 0 ? (0, _toConsumableArray2.default)(this.form.deliveryVehiclePlates) : null,
        attachment: this.attachmentList.length > 0 ? (0, _toConsumableArray2.default)(this.attachmentList) : null
      };
    },
    getSubmitDataPatch: function getSubmitDataPatch(submitData) {
      var _this12 = this;

      submitData.sendDate = this.form.sendDate || '';
      submitData.sendTime = Array.isArray(this.form.doorTime) ? this.form.doorTime.join('-') : this.form.doorTime || '';
      submitData.sendPerson = this.form.deliveryDriver && this.form.deliveryDriver.length ? JSON.stringify(this.form.deliveryDriver.map(function (uid) {
        var d = _this12.allDriverList.find(function (item) {
          return item.userId === uid;
        });

        return {
          userId: uid,
          userName: d ? d.realName : '',
          userPhone: d ? d.phone : ''
        };
      })) : '';
      submitData.driverPhone = this.form.deliveryDriver && this.form.deliveryDriver.length ? this.form.deliveryDriver.map(function (uid) {
        var d = _this12.allDriverList.find(function (item) {
          return item.userId === uid;
        });

        return d ? d.phone : '';
      }).filter(Boolean).join('、') : '';
      submitData.carNumber = this.form.deliveryVehicle && this.form.deliveryVehicle.length ? this.form.deliveryVehicle.join(',') : '';
      submitData.hasLargeFurniture = this.form.hasLargeFurniture || '';
      submitData.enterType = this.form.enterType || '';
      submitData.enterRemark = this.form.enterRemark || '';
      submitData.remark = this.form.remark || '';

      if (this.attachmentList.length > 0) {
        submitData.attachment = JSON.stringify(this.attachmentList);
      }

      return submitData;
    },
    getRules: function getRules() {
      return {
        hasLargeFurniture: [{
          required: true,
          message: '请选择有无大家居',
          trigger: 'submit'
        }],
        sendDate: [{
          required: true,
          trigger: 'submit',
          validator: this.validateSendDate
        }],
        doorTime: [{
          required: true,
          trigger: 'submit',
          validator: this.validateDoorTime
        }],
        enterType: [{
          required: true,
          message: '请选择进门方式',
          trigger: 'submit'
        }],
        deliveryDriver: [],
        deliveryVehicle: [],
        receivePerson: [{
          required: true,
          message: '请输入收货人',
          trigger: 'submit'
        }],
        receivePhone: [{
          required: true,
          message: '请输入收货人电话',
          trigger: 'submit'
        }, {
          validator: _validate.validatePhone,
          trigger: 'submit'
        }],
        receiveAddress: [{
          required: true,
          message: '收货信息必填',
          trigger: 'submit'
        }],
        coordinate: [{
          required: true,
          message: '请输入坐标',
          trigger: 'submit'
        }]
      };
    },
    fillDeliveryInfo: function fillDeliveryInfo(deliveryLog) {
      return {};
    },
    // ==================== 校验方法 ====================
    validateSendDate: function validateSendDate(rule, value, callback) {
      if (!value) {
        callback(new Error('请选择上门日期'));
        return;
      }

      var today = new Date();
      var todayStr = today.getFullYear() + '-' + String(today.getMonth() + 1).padStart(2, '0') + '-' + String(today.getDate()).padStart(2, '0');

      if (value < todayStr) {
        callback(new Error('上门日期不能早于今天'));
        return;
      }

      callback();
    },
    validateDoorTime: function validateDoorTime(rule, value, callback) {
      if (!value || !Array.isArray(value) || !value[0]) {
        callback(new Error('请选择上门时间'));
        return;
      } // 日期：上门日期为空时取当天，不为空取上门日期


      var now = new Date();
      var dateStr = this.form.sendDate || now.getFullYear() + '-' + String(now.getMonth() + 1).padStart(2, '0') + '-' + String(now.getDate()).padStart(2, '0');
      var startDateTime = new Date(dateStr + ' ' + value[0] + ':00');

      if (startDateTime.getTime() <= now.getTime()) {
        callback(new Error('开始时间不能小于当前时间'));
        return;
      }

      if (value[0] && value[1]) {
        var startParts = value[0].split(':').map(Number);
        var endParts = value[1].split(':').map(Number);
        var startMinutes = startParts[0] * 60 + startParts[1];
        var endMinutes = endParts[0] * 60 + endParts[1];

        if (endMinutes <= startMinutes) {
          callback(new Error('结束时间不能小于开始时间'));
          return;
        }
      }

      callback();
    },
    parseSendPerson: function parseSendPerson(sendPerson) {
      if (!sendPerson) return [];

      try {
        var parsed = JSON.parse(sendPerson);
        return Array.isArray(parsed) ? parsed : [];
      } catch (_unused3) {
        return sendPerson.split(',').filter(Boolean).map(function (name) {
          return {
            userId: '',
            userName: name
          };
        });
      }
    },
    // ==================== 配送日志 ====================
    loadLog: function loadLog() {
      var _this13 = this;

      var sendNumber = this.form.deliveryNo;
      if (!sendNumber) return Promise.resolve();
      if (this._loadingLog) return this._loadingLog;
      this._loadingLog = (0, _send.getSendTaskLog)({
        page: 0,
        size: 1000,
        sendNumber: sendNumber
      }).then(function (res) {
        if (res.code === 200 && res.data && res.data.content) {
          var logs = res.data.content;
          var log = {
            reserveTimeliness: '',
            arrivalTimeliness: ''
          };
          var reserveTime = null;
          var signTime = null;

          var deadline = _this13.calcDeadline();

          logs.forEach(function (item) {
            var step = item.step || '';

            if (step === '10') {
              log.reservePerson = item.createByName || item.createBy;
              log.reserveTime = item.createTime;
              reserveTime = item.createTime;
              log.reserveRemark = item.remark || '';

              if (item.photo) {
                log.reservePhoto = item.photo.split(',').filter(Boolean).map(function (url) {
                  return {
                    url: url.trim()
                  };
                });
              }
            } else if (step === '-1') {
              if (!log.exceptionList) log.exceptionList = [];
              log.exceptionList.push({
                person: item.createByName || item.createBy,
                remark: item.remark || '',
                time: item.createTime || '',
                photo: item.photo ? item.photo.split(',').filter(Boolean).map(function (url) {
                  return {
                    url: url.trim()
                  };
                }) : []
              });
            } else if (step === '20') {
              log.loadingPerson = item.createByName || item.createBy;
              log.departureTime = item.createTime;

              if (item.photo) {
                try {
                  var photoData = JSON.parse(item.photo);

                  if (photoData.loadingImages) {
                    log.loadingPhoto = _this13.parseAttachmentUrls(photoData.loadingImages);
                  } else {
                    log.loadingPhoto = item.photo.split(',').filter(Boolean).map(function (url) {
                      return {
                        url: url.trim()
                      };
                    });
                  }
                } catch (e) {
                  log.loadingPhoto = item.photo.split(',').filter(Boolean).map(function (url) {
                    return {
                      url: url.trim()
                    };
                  });
                }
              }
            } else if (step === '30') {
              log.checkInPerson = item.createByName || item.createBy;
              log.checkInTime = item.createTime;
              signTime = item.createTime;

              if (item.remark) {
                log.checkInAnomaly = true;
                log.checkInAnomalyRemark = item.remark;
              }

              if (item.photo) {
                log.checkInAnomalyPhoto = item.photo.split(',').filter(Boolean).map(function (url) {
                  return {
                    url: url.trim()
                  };
                });
              }
            } else if (step === '40') {
              log.deliverPerson = item.createByName || item.createBy;
              log.deliverTime = item.createTime;
              log.deliverCabinetCount = item.quantity;
              log.deliverPackageCount = item.quantity;

              if (item.photo) {
                try {
                  var _photoData = JSON.parse(item.photo);

                  if (_photoData.checkImages) {
                    log.siteCheckPhoto = _this13.parseAttachmentUrls(_photoData.checkImages);
                  }

                  if (_photoData.deliveryImages) {
                    log.deliveryCompletePhoto = _this13.parseAttachmentUrls(_photoData.deliveryImages);
                  }

                  if (_photoData.deliveryNoteImages) {
                    log.deliveryOrderPhoto = _this13.parseAttachmentUrls(_photoData.deliveryNoteImages);
                  }

                  if (_photoData.installImages) {
                    log.installPhoto = _this13.parseAttachmentUrls(_photoData.installImages);
                  }
                } catch (e) {
                  var photos = item.photo.split(',').filter(Boolean).map(function (u) {
                    return {
                      url: u.trim()
                    };
                  });
                  log.siteCheckPhoto = photos;
                  log.deliveryCompletePhoto = photos;
                  log.deliveryOrderPhoto = photos;
                }
              }

              if (item.video) {
                try {
                  var parsed = JSON.parse(item.video);
                  log.siteCheckVideo = Array.isArray(parsed) ? parsed.map(function (url) {
                    return {
                      url: url
                    };
                  }) : [{
                    url: item.video
                  }];
                } catch (_unused4) {
                  log.siteCheckVideo = [{
                    url: item.video
                  }];
                }
              }
            } else if (step === '50') {
              log.accountingPerson = item.createByName || item.createBy;
              log.accountingTime = item.createTime;
              log.accountingPackageCount = item.quantity;

              if (item.photo) {
                try {
                  var accountingData = JSON.parse(item.photo);

                  if (accountingData.items) {
                    log.accountingItems = accountingData.items;
                  }
                } catch (e) {
                  log.accountingItems = [];
                }
              }
            }
          });

          if (reserveTime && deadline) {
            var diffMinutes = (deadline.getTime() - new Date(reserveTime).getTime()) / (1000 * 60);
            log.reserveTimeliness = diffMinutes >= 30 ? '准时预约' : '超时预约';
          }

          if (signTime && deadline) {
            log.arrivalTimeliness = new Date(signTime).getTime() <= deadline.getTime() ? '准时到达' : '超时到达';
          }

          _this13.logData = log;

          _this13.$emit('log-loaded', log);

          _this13.startCountdown();

          return logs;
        }

        return null;
      }).catch(function (err) {
        console.error('加载送货日志失败:', err);
        return null;
      }).finally(function () {
        _this13._loadingLog = null;
      });
      return this._loadingLog;
    },
    calcDeadline: function calcDeadline() {
      var sendDate = this.form.sendDate;
      if (!sendDate) return null;
      var endTimeStr = '23:59:59';
      var sendTime = this.form.doorTime;

      if (sendTime && sendTime.length === 2 && sendTime[1]) {
        endTimeStr = sendTime[1];
      } else if (typeof sendTime === 'string' && sendTime) {
        var parts = sendTime.split('-');
        endTimeStr = parts.length > 1 ? parts[1].trim() : sendTime.trim();
      }

      if (endTimeStr.split(':').length === 2) endTimeStr += ':00';
      return new Date(sendDate + ' ' + endTimeStr);
    },
    parseAttachmentUrls: function parseAttachmentUrls(data) {
      if (!data) return [];

      try {
        var parsed = typeof data === 'string' ? JSON.parse(data) : data;
        var arr = Array.isArray(parsed) ? parsed : [];
        if (arr.length === 0) return [];
        var imgPreviewPrefix = this.$store.getters.imgPreviewPrefix || '';
        return arr.map(function (item) {
          if (typeof item === 'string') {
            try {
              var o = JSON.parse(item);
              return {
                url: o.url || imgPreviewPrefix + o.realName,
                realName: o.realName
              };
            } catch (_unused5) {
              return {
                url: item.startsWith('http') ? item : imgPreviewPrefix + item
              };
            }
          }

          return {
            url: item.url || imgPreviewPrefix + item.realName,
            realName: item.realName
          };
        });
      } catch (_unused6) {
        return [];
      }
    },
    startCountdown: function startCountdown() {
      var _this14 = this;

      if (this._countdownTimer) clearInterval(this._countdownTimer);
      this.updateReserveCountdown();
      this.updateDepartCountdown();
      this._countdownTimer = setInterval(function () {
        _this14.updateReserveCountdown();

        _this14.updateDepartCountdown();
      }, 1000);
    },
    updateReserveCountdown: function updateReserveCountdown() {
      if (this.sendStatus !== 10) return;

      if (!this.form.sendDate) {
        this.reserveCountdownText = '-';
        return;
      }

      try {
        var datePart = this.form.sendDate;
        var timePart = '00:00:00';
        var doorTime = this.form.doorTime;

        if (doorTime && doorTime.length === 2 && doorTime[0]) {
          timePart = doorTime[0];
        } else if (typeof doorTime === 'string' && doorTime) {
          timePart = doorTime.includes('-') ? doorTime.split('-')[0].trim() : doorTime.trim();
        }

        if (timePart.split(':').length === 2) timePart += ':00';
        var targetTime = new Date(datePart + ' ' + timePart).getTime();
        var diffSeconds = Math.floor((targetTime - Date.now()) / 1000);

        if (diffSeconds < 0) {
          this.reserveCountdownText = '超时';
          return;
        }

        var days = Math.floor(diffSeconds / 86400);
        var hours = Math.floor(diffSeconds % 86400 / 3600);
        var minutes = Math.floor(diffSeconds % 3600 / 60);
        var seconds = diffSeconds % 60;
        var dayStr = days > 0 ? days + '天 ' : '';
        this.reserveCountdownText = dayStr + String(hours).padStart(2, '0') + ':' + String(minutes).padStart(2, '0') + ':' + String(seconds).padStart(2, '0');
      } catch (e) {
        this.reserveCountdownText = '00:00:00';
      }
    },
    updateDepartCountdown: function updateDepartCountdown() {
      if (this.sendStatus !== 20) return;

      if (!this.form.sendDate) {
        this.departCountdownText = '-';
        return;
      }

      try {
        var deadline = this.calcDeadline();

        if (!deadline) {
          this.departCountdownText = '-';
          return;
        }

        var diffSeconds = Math.floor((deadline.getTime() - Date.now()) / 1000);

        if (diffSeconds < 0) {
          this.departCountdownText = '已超时';
          return;
        }

        var days = Math.floor(diffSeconds / 86400);
        var hours = Math.floor(diffSeconds % 86400 / 3600);
        var minutes = Math.floor(diffSeconds % 3600 / 60);
        var seconds = diffSeconds % 60;
        var dayStr = days > 0 ? days + '天 ' : '';
        this.departCountdownText = dayStr + String(hours).padStart(2, '0') + ':' + String(minutes).padStart(2, '0') + ':' + String(seconds).padStart(2, '0');
      } catch (e) {
        this.departCountdownText = '00:00:00';
      }
    },
    getAccountingSummary: function getAccountingSummary(_ref) {
      var _this15 = this;

      var columns = _ref.columns,
          data = _ref.data;
      var sums = [];
      var totalDeliveryCommission = data.reduce(function (sum, row) {
        return sum + (row.deliveryCommission || 0);
      }, 0);
      var totalBigHomeInstallCommission = data.reduce(function (sum, row) {
        return sum + (row.bigHomeInstallCommission || 0);
      }, 0);
      var totalFloorCount = data.reduce(function (sum, row) {
        return sum + (row.floorCount || 0);
      }, 0);
      var totalFloorCommission = data.reduce(function (sum, row) {
        return sum + (row.floorCommission || 0);
      }, 0);
      var totalOtherCommission = data.reduce(function (sum, row) {
        return sum + (row.otherCommission || 0);
      }, 0);
      columns.forEach(function (col, index) {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }

        switch (index) {
          case 3:
            sums[index] = _this15.accountingTotalPackages;
            break;

          case 4:
            sums[index] = _this15.accountingTotalInPackages;
            break;

          case 5:
            sums[index] = _this15.accountingTotalArea.toFixed(2);
            break;

          case 6:
            sums[index] = _this15.accountingTotalVol.toFixed(2);
            break;

          case 7:
            sums[index] = totalDeliveryCommission;
            break;

          case 8:
            sums[index] = totalBigHomeInstallCommission;
            break;

          case 9:
            sums[index] = totalFloorCount;
            break;

          case 10:
            sums[index] = totalFloorCommission;
            break;

          case 11:
            sums[index] = totalOtherCommission;
            break;

          default:
            sums[index] = '';
        }
      });
      return sums;
    },
    handleAccountingSubmit: function handleAccountingSubmit() {
      var _this16 = this;

      this.$confirm('确认提交核算信息？提交后状态将变更为"已核算"，不可再修改。', '确认提交', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this16.accountingSubmitting = true;

        var items = _this16.contractList.map(function (s) {
          var item = {
            orderSolutionId: s.id
          };
          if (s.deliveryCommission != null) item.deliveryCommission = s.deliveryCommission;
          if (s.bigHomeInstallCommission != null) item.bigHomeInstallCommission = s.bigHomeInstallCommission;
          if (s.floorCount != null) item.floorCount = s.floorCount;
          if (s.floorCommission != null) item.floorCommission = s.floorCommission;
          if (s.otherCommission != null) item.otherCommission = s.otherCommission;
          if (s.accountingRemark != null) item.accountingRemark = s.accountingRemark;
          return item;
        });

        (0, _send.accountingSubmit)(_this16.detailId, {
          items: items
        }).then(function () {
          _this16.$message.success('核算提交成功');

          _this16.loadLog();

          _this16.accountingSubmitting = false;

          _this16.$emit('reload-contract');
        }).catch(function () {
          _this16.$message.error('核算提交失败，请重试');

          _this16.accountingSubmitting = false;
        });
      }).catch(function () {});
    },
    handleAccountingSave: function handleAccountingSave() {
      var _this17 = this;

      this.accountingSaving = true;
      var items = this.contractList.map(function (s) {
        var item = {
          orderSolutionId: s.id
        };
        if (s.deliveryCommission != null) item.deliveryCommission = s.deliveryCommission;
        if (s.bigHomeInstallCommission != null) item.bigHomeInstallCommission = s.bigHomeInstallCommission;
        if (s.floorCount != null) item.floorCount = s.floorCount;
        if (s.floorCommission != null) item.floorCommission = s.floorCommission;
        if (s.otherCommission != null) item.otherCommission = s.otherCommission;
        if (s.accountingRemark != null) item.accountingRemark = s.accountingRemark;
        return item;
      });
      (0, _send.accountingSave)(this.detailId, {
        items: items
      }).then(function () {
        _this17.$message.success('核算暂存成功');

        _this17.accountingSaving = false;
      }).catch(function () {
        _this17.$message.error('核算暂存失败，请重试');

        _this17.accountingSaving = false;
      });
    }
  }
};
exports.default = _default2;